import { t } from 'i18next';

export interface LocationCoordinates {
  latitude: number;
  longitude: number;
  accuracy: number | null;
}

async function checkLocationPermission(): Promise<boolean> {
  if (!('geolocation' in navigator)) {
    return false;
  }

  const result = await navigator.permissions.query({ name: 'geolocation' });
  return result.state !== 'denied';
}

export async function getLocationAsync(): Promise<LocationCoordinates> {
  const hasPermission = await checkLocationPermission();

  if (!hasPermission) {
    throw new Error('Location permission is required to proceed.');
  }

  return new Promise<LocationCoordinates>((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
        });
      },
      (error) => {
        reject(new Error(`${t('login.LocationMandatoryShortMessage')} ${error.message}`));
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  });
}

export function convertCurrentTimeToPSTFormat(): string {
  return new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
}
